import { Button, FormLabel, Grid, Input, Modal } from "@mui/material";
import { FunctionComponent } from "react";
import ContainerModal from "../../../../components/modalExportar/components/containerModal";
import useNav from "../../../../hooks/useNav";
import useServicesVisitanteEdit from "./servicesEdit";


interface EditVisitanteProps {

}

const EditVisitante: FunctionComponent<EditVisitanteProps> = () => {

  const { goBack } = useNav()

  const { visitante, handleUpdate, alterVisitante } = useServicesVisitanteEdit();

  return (<>
    <Modal open onClose={goBack}>
      <ContainerModal>
        <Grid sx={{ mb: 1, paddingY: 1, borderBottom: '1px solid #ccc' }}>
          <p style={{ fontSize: '16px', fontWeight: 600 }}>Visitante</p>
        </Grid>
        <Grid display={'grid'} gap={1}>
          <Grid display={'grid'}>
            <FormLabel>
              Nome
            </FormLabel>
            <Input
              value={visitante?.nome}
              onChange={(event) => alterVisitante('nome', event?.target?.value)}
            />
          </Grid>
          <Grid display={'grid'}>
            <FormLabel>
              Email
            </FormLabel>
            <Input
              value={visitante?.email}
              onChange={(event) => alterVisitante('email', event?.target?.value)}
            />
          </Grid>
          <Grid display={'grid'}>
            <FormLabel>
              Telefone
            </FormLabel>
            <Input
              type="tel"
              value={visitante?.telefone}
              onChange={(event) => alterVisitante('telefone', event?.target?.value)}
            />
          </Grid>
        </Grid>
        <Grid display={'flex'} justifyContent={'space-between'} mt={1}>
          <Button color="error" onClick={goBack}>Cancelar</Button>
          <Button variant="contained" sx={{ boxShadow: 'none' }} onClick={handleUpdate}>Confirmar</Button>
        </Grid>
      </ContainerModal>
    </Modal>
  </>);
}

export default EditVisitante;
